<div class="tab-scroller">
  <div class="ui-tabview ui-widget ui-widget-content ui-tabview-top">
    <ul
      class="ui-tabview-nav ui-helper-reset ui-helper-clearfix ui-widget-header"
      style="padding-left: 0"
    >
      <li
        (click)="onTabClick(tab)"
        *ngFor="let tab of tabs"
        [class.ui-state-active]="tabIndex == tab.index"
        [class.ui-state-default]="tabIndex != tab.index"
      >
        <a>
          <ng-container *ngIf="templateRef; else defaultTemplate">
            <ng-template
              [ngTemplateOutlet]="templateRef"
              [ngTemplateOutletContext]="{ $implicit: tab }"
            >
            </ng-template>
          </ng-container>
          <ng-template #defaultTemplate>
            {{ tab.label }}
          </ng-template>
        </a>
      </li>
    </ul>
  </div>
</div>
